/**
 * Logs an error when a TCAPI-source signal reaches the FE without the
 * `text_to_911_tcapi_0` capability enabled on the current PSAP — likely
 * provisioning drift (credentials present, capability off) or a stray
 * test call. `console.error` routes to Sentry in this codebase.
 */
export interface MissingTT911CapabilityContext {
  callSite: string;
  callerId?: string | null;
  orgName?: string | null;
  source?: string | null;
  extra?: Record<string, unknown>;
}

export function logMissingTT911Capability(
  ctx: MissingTT911CapabilityContext,
): void {
  // eslint-disable-next-line no-console -- intentional: console.error routes to Sentry
  console.error(
    '[TT911] TCAPI-source signal received without text_to_911_tcapi_0 capability — provisioning drift or stray test call',
    {
      callSite: ctx.callSite,
      callerId: ctx.callerId ?? null,
      orgName: ctx.orgName ?? null,
      source: ctx.source ?? null,
      ...(ctx.extra ?? {}),
    },
  );
}
